<template>
  <div class="flex items-center gap-1">
<AppLink @click="toggleExpanded">
      <slot>        
        <span v-if="showLabel">{{ modelValue ? 'Collapse all' : 'Expand all' }}</span>
      </slot>
      <i class="fas ml-1" :class="modelValue ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </AppLink>
  </div>
</template>

<script setup lang="ts">
import AppLink from '@/components/AppLink.vue';

interface Props {
  modelValue: boolean;
  showLabel?: boolean;
}

const props = withDefaults(defineProps<Props>() , {
  showLabel: true
});
const emit = defineEmits(['update:modelValue']);

const toggleExpanded = () => {
  emit('update:modelValue', !props.modelValue);
};
</script>
